<script lang="ts">
	let customClass = "";
	export { customClass as class };
	export let hoverClass = "group-hover:opacity-100";
</script>

<div
	class="pointer-events-none absolute left-0 right-0 top-full z-10 mt-2 text-xs opacity-0 transition-opacity duration-300 {hoverClass}"
>
	<div class="bg-secondary-150 border-secondary-250 text-secondary mx-auto w-fit rounded-md border p-2 {customClass}">
		<slot />
	</div>
</div>
